import React, { createContext, useContext, useState } from 'react';
import FindBestFitQuiz from '../components/FindBestFitQuiz';

const QuizContext = createContext({ open: () => {}, close: () => {} });

export const useQuiz = () => useContext(QuizContext);

export default function QuizProvider({ children }) {
  const [isOpen, setIsOpen] = useState(false);
  const value = { open: () => setIsOpen(true), close: () => setIsOpen(false) };
  return (
    <QuizContext.Provider value={value}>
      {children}
      <FindBestFitQuiz open={isOpen} onClose={value.close} />
    </QuizContext.Provider>
  );
}
